import React from 'react'
import PropTypes from 'prop-types'
import Col from "../Col"
import Container from "../Container"
import './InfoBanner.sass'

const InfoBanner = ({theme, caption, children}) => {
  if (!children){
    return null
  }
  return (
    <div className={`info-banner-wrapper info-banner--${theme}`}>
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <p className="info-banner-text">
            <span className="info-banner-caption">
              {caption}
            </span>
            {children}
          </p>
        </Col>
      </Container>
    </div>
  )
}

InfoBanner.propTypes = {
  theme: PropTypes.string,
  caption: PropTypes.string,
  children: PropTypes.string.isRequired
}

InfoBanner.defaultProps = {
  theme: 'success',
  caption: ''
}

export default InfoBanner



// WEBPACK FOOTER //
// ./components/InfoBanner/index.jsx